define('app/visualizations/ScatterPlot',['require','glu/util','./SimpleCategoricalChartView','app/visualizations/FormatFactory'],function(require) {
	'use strict';

	var _ = require('glu/util'),
		SimpleCategoricalChartView = require('./SimpleCategoricalChartView'),
		FormatFactory = require('app/visualizations/FormatFactory');

	return SimpleCategoricalChartView.extend({
		type: 'scatter',

		/**
		 * Get data used to populate the chart.
		 */
		getChartData: function(results) {
			return results.scatterPlotData();
		},

		/**
		 * Get default options for rendering the chart.  Also provides callers the opportunity to customize
		 * various settings such as height, width, etc.
		 */
		getChartOptions: function(data) {
			var self = this;

			var getDataFormatX = function(d) {
				var column = self.model.columns().models.filter(function(col) {
					return col.get('aggregation');
				})[0];

				var options = {};

				if (column) {
					options = {
						enumeration: column.get('enumeration'),
						aggregation: column.get('aggregation'),
						displayFormat: column.get('displayFormat')
					};

					if (column.get('isPercentage')) {
						options.percentage = {
							total: column.get('total')
						};
					}

					options.dataType = column.get('fieldObject').get('type');
				}

				return FormatFactory.formatterForType(options.dataType, options)(d);
			};

			var getDataFormatY = function(d) {
				var column = self.model.columns().models.filter(function(col) {
					return col.get('aggregation');
				})[1];

				var options = {};

				if (column) {
					options = {
						enumeration: column.get('enumeration'),
						aggregation: column.get('aggregation'),
						displayFormat: column.get('displayFormat')
					};

					if (column.get('isPercentage')) {
						options.percentage = {
							total: column.get('total')
						};
					}

					options.dataType = column.get('fieldObject').get('type');
				}

				return FormatFactory.formatterForType(options.dataType, options)(d);
			};

			var tooltipFormat = function(name, value) {
				var column = self.model.columns().models.filter(function(col) {
					return col.get('asName') === name;
				})[0];

				var options = {};

				if (column) {
					options = {
						enumeration: column.get('enumeration'),
						aggregation: column.get('aggregation'),
						displayFormat: column.get('displayFormat')
					};

					if (column.get('isPercentage')) {
						options.percentage = {
							total: column.get('total')
						};
					}

					options.dataType = column.get('fieldObject').get('type');
				}

				return FormatFactory.formatterForType(options.dataType, options)(value);
			};

			var options = {
				c3: {
					size: {
						height: this.height || this.$el.height(),
						width: this.width
					},
					legend: {
						position: 'right',
						show: false
					},
					data: {
						labels: true,
						type: this.type,
						columns: data.columns,
						x: data.x
					},
					tooltip: {
						contents: function(d) {
							var column1Values = data.columns[0],
								categories = data.categories,
								radii = data.r,
								index = -1,
								radius = false,
								radiusLabel = data.rTitle;

							// figure out the correct header name for the tooltip
							_.each(column1Values, function(x, i) {
								if (Number(x) === Number(d[0].x)) {
									index = i;
								}
							});
							var header = categories[index - 1];

							// see if we have a radius specified
							if (!_.isEmpty(radii)) {
								radius = radii[index - 1];
							}

							var returnVal = '<div class="c3-tooltip-container"><table class="c3-tooltip"><tbody><tr><th colspan="2">' + header + '</th></tr>' + '<tr class="c3-tooltip-name-col1"><td class="name">' + d[0].name + '</td><td class="value">' + tooltipFormat(d[0].name, d[0].value) + '</td></tr>' + '<tr class="c3-tooltip-name-col2"><td class="name">' + this.config.data_x + '</td><td class="value">' + tooltipFormat(this.config.data_x, d[0].x) + '</td></tr>';

							if (radius) {
								returnVal = returnVal + '<tr class="c3-tooltip-name-col1"><td class="name">' + radiusLabel + '</td><td class="value">' + tooltipFormat(radiusLabel, radius) + '</td></tr>';
							}

							returnVal = returnVal + '</tbody></table></div>';

							return returnVal;
						}
					},
					padding: {
						top: this.paddingTop,
						right: this.paddingRight,
						bottom: this.paddingBottom,
						left: this.paddingLeft
					},
					point: {
						r: function(d) {
							var r = data.r,
								column1Values = data.columns[0],
								index = -1,
								rMax = _.max(data.r);

							_.each(column1Values, function(x, i) {
								if (Number(x) === Number(d.x)) {
									index = i;
								}
							});

							return _.isEmpty(r) ? 5 : (r[index - 1] / rMax) * 100;
						}
					},
					axis: {
						x: {
							tick: {
								fit: false,
								format: getDataFormatX
							}
						},
						y: {
							padding: {
								bottom: 25
							},
							min: 0,
							tick: {
								format: getDataFormatY
							}
						}
					}
				}
			};

			// special handling for tick marks.
			if (!this.showTicks) {
				this.$el.addClass('hide-ticks');

				options.c3.axis.x.tick = {
					outer: false,
					fit: false
				};

				options.c3.axis.y.tick = {
					outer: false
				};
			}

			if (this.fixToolTips) {
				options.c3.tooltip = {
					position: function() {
						return {
							top: 0,
							left: 0
						};
					}
				};
			}

			return options;
		}
	});

});

